import { AxiosError } from "axios";

export class TelevisionNotExistsError extends Error {
  constructor(error: AxiosError) {
    super(error.message);
    this.message = 'television.not.exist';
    this.name = "TelevisionNotExistsError";
  }
}
